import { defineMessages } from "react-intl";

import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import CommonFieldName from "./CommonFieldName";
import DateTimeField from "./impl/DateTimeField";
import FieldModel from "./impl/FieldModel";
import { createField } from "./impl/fieldModelUtil";
import NameField from "./impl/NameField";
import UserField from "./impl/UserField";

export enum ReportFieldName {
  LAST_GENERATED_AT = "lastGeneratedAt",
  NAME = CommonFieldName.NAME,
  STARRED = "isStarred",
  TABLE_NAME = "tableName",
  USER = CommonFieldName.USER,
}

const displayNames = defineMessages<ReportFieldName>({
  [ReportFieldName.LAST_GENERATED_AT]: {
    id: "report.field.lastGeneratedAt",
    defaultMessage: "Last Generated At",
    description: "Last Generated At field of report",
  },
  [ReportFieldName.NAME]: {
    id: "report.field.name",
    defaultMessage: "Name",
    description: "Name field of report",
  },
  [ReportFieldName.STARRED]: {
    id: "report.field.starred",
    defaultMessage: "Favorite",
    description: "Favorite field of report",
  },
  [ReportFieldName.TABLE_NAME]: {
    id: "report.field.tableName",
    defaultMessage: "Table Name",
    description: "Table Name field of report",
  },
  [ReportFieldName.USER]: {
    id: "report.field.user",
    defaultMessage: "Creator",
    description: "Creator field of report",
  },
});

const reportFieldModel = new FieldModel(
  [
    new DateTimeField({
      displayName: displayNames[ReportFieldName.LAST_GENERATED_AT],
      name: ReportFieldName.LAST_GENERATED_AT,
    }),
    new NameField({
      displayName: displayNames[ReportFieldName.NAME],
      name: ReportFieldName.NAME,
    }),
    {
      displayName: displayNames[ReportFieldName.TABLE_NAME],
      name: ReportFieldName.TABLE_NAME,
      type: FieldType.STRING,
    },
    {
      displayName: displayNames[ReportFieldName.STARRED],
      name: ReportFieldName.STARRED,
      type: FieldType.BOOLEAN,
    },
    new UserField({
      displayName: displayNames[ReportFieldName.USER],
      name: ReportFieldName.USER,
      platformFilterNames: ["userId", "user.id"],
    }),
  ].map(createField)
);

export default reportFieldModel;
